import Model from './model';

export default class LogicBaseMessage extends Model {
  constructor(_id, createdTime, updateTime, conversation, sender, text, attachments = [], editedTime) {
    super();
    this._id = _id;
    this.createdTime = createdTime;
    this.updateTime = updateTime;
    this.conversation = conversation;
    this.sender = sender;
    this.text = text;
    this.attachments = attachments;
    this.editedTime = editedTime;
  }
  getJson = () => {
    const { _id, text, attachments } = this;
    return {
      _id,
      text,
      attachments,
    };
  }
}
